
import React from 'react';
import classnames from 'classnames';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';


export default class UmlaufplanAuswahl extends React.Component {

    render() {

        var {open, classes, hide, loading, umlaufplaene, auswahl} = this.props

        if(loading) {
            return (
                <Dialog open={open} className={classes.progress}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            )
        }

        return (
            <Dialog open={open} onClose={hide}>
                {this.props.children && this.props.children}
                <DialogTitle>Umlaufplan auswählen</DialogTitle>
                <List>
                    {umlaufplaene && umlaufplaene.map((plan, index) => {
                        var name = []
                        if(plan.paket) {
                            name.push(<span><b>{plan.paket}</b> / </span>)
                        }
                        if(plan.kuerzel) {
                            name.push(<span><b>{plan.kuerzel}</b> / </span>)
                        }
                        if(plan.name) {
                            name.push(plan.name)
                        }
                        var secondary = []
                        secondary.push(plan.gueltig)
                        if (plan.gueltig && plan.start) {
                            secondary.push(", ")
                        }
                        secondary.push(plan.start)
                        if(plan.ende) {
                            secondary.push(" - ")
                        }
                        secondary.push(plan.ende)
                        if(plan.minuten) {
                            secondary.push(" min. ")
                            secondary.push(plan.minuten)
                        }
                        return (
                            <ListItem button onClick={() => auswahl(plan.id, plan)}>
                                <div className={"color-block"} style={{backgroundColor: plan.farbe}}></div>
                                <ListItemText primary={name} secondary={secondary} />
                            </ListItem>
                        )
                    })}
                    
                </List>
            </Dialog>
        )
    }

}


// WEBPACK FOOTER //
// ./src/Components/UmlaufplanAuswahl.js